import { scheduleFiltersActions } from '../actions'
import { useActions, useAppSelector } from '../../../store/hooks'
import { referencesSelector } from '../../../store/slices/references'
import { schedulePageSelector } from '../../../store/slices/schedulePage'

export function useScheduleFilters() {
    const dateFrom = useAppSelector(schedulePageSelector.dateFrom)
    const dateTo = useAppSelector(schedulePageSelector.dateTo)
    const viewMode = useAppSelector(schedulePageSelector.viewMode)
    const selectedGroupId = useAppSelector(schedulePageSelector.selectedGroupId)
    const selectedTeacherId = useAppSelector(schedulePageSelector.selectedTeacherId)
    const selectedBuildId = useAppSelector(schedulePageSelector.selectedBuildId)
    const selectedRoomId = useAppSelector(schedulePageSelector.selectedRoomId)
    const selectedClassTypeId = useAppSelector(schedulePageSelector.selectedClassTypeId)
    const selectedSubjectId = useAppSelector(schedulePageSelector.selectedSubjectId)
    const showMoreOptions = useAppSelector(schedulePageSelector.showMoreOptions)
    const isValidGroupValue = useAppSelector(schedulePageSelector.isValidGroupValue)
    const isValidTeacherValue = useAppSelector(schedulePageSelector.isValidTeacherValue)
    const groupOptions = useAppSelector(referencesSelector.groupOptions)
    const teacherOptions = useAppSelector(referencesSelector.teacherOptions)
    const buildingOptions = useAppSelector(referencesSelector.buildingOptions)
    const roomOptions = useAppSelector(referencesSelector.roomOptions)
    const classTypeOptions = useAppSelector(referencesSelector.classTypeOptions)
    const subjectOptions = useAppSelector(referencesSelector.subjectOptions)

    const {
        resetSchedule,
        referenceLoadAudience,
        setDateRange,
        clearDateFilter,
        setViewMode,
        setSelectedGroupId,
        setSelectedTeacherId,
        setSelectedBuildId,
        setSelectedRoomId,
        setSelectedClassTypeId,
        setSelectedSubjectId,
        resetFilters,
        toggleShowMoreOptions,
    } = useActions(scheduleFiltersActions)

    const changeViewMode = (mode) => {
        setViewMode(mode)
        resetSchedule()
    }

    const selectBuild = (value) => {
        setSelectedBuildId(value)
        referenceLoadAudience(value || null)
    }

    return {
        dateFrom,
        dateTo,
        viewMode,
        selectedGroupId,
        selectedTeacherId,
        selectedBuildId,
        selectedRoomId,
        selectedClassTypeId,
        selectedSubjectId,
        showMoreOptions,
        isValidGroupValue,
        isValidTeacherValue,
        groupOptions,
        teacherOptions,
        buildingOptions,
        roomOptions,
        classTypeOptions,
        subjectOptions,
        setDateRange,
        clearDateFilter,
        changeViewMode,
        setSelectedGroupId,
        setSelectedTeacherId,
        selectBuild,
        setSelectedRoomId,
        setSelectedClassTypeId,
        setSelectedSubjectId,
        resetFilters,
        toggleShowMoreOptions,
    }
}
